import { action } from '@ember/object';
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';
import Store from '@ember-data/store';
import { allowTransitionIfCleanStocktaking } from 'bcl/misc/transition';
import type LocationModel from 'bcl/models/location';
import type SessionService from 'bcl/services/session';
import type StocktakingModel from 'bcl/models/stocktaking';
import type StocktakingService from 'bcl/services/stocktaking';

export default class StocktakingRoute extends Route {
  @service declare store: Store;
  @service declare session: SessionService;
  @service declare stocktaking: StocktakingService;
  async model(params) {
    console.log('model stock', params.id);
    const stocktaking = this.store.peekRecord('stocktaking', params.id);
    const allLocations = this.store.peekAll('location');

    // only used for import from admin page
    if (!this.session.stocktakingSkipInital) {
      Promise.all(
        allLocations.map((location) =>
          _initLocation(location, stocktaking, this.store)
        )
      );
    }
    this.session.stocktakingSkipInital = false;

    return { allLocations, stocktaking };
  }

  @action
  willTransition(transition: Transition) {
    return allowTransitionIfCleanStocktaking(this, transition);
  }
}
export async function _initLocation(
  location: LocationModel,
  stocktaking: StocktakingModel,
  store: Store
) {
  if (!location?.active) {
    return;
  }
  // make sure we have a location-item for each (and save it)
  // then make sure for every li we have an ste
  const allItems =
    store
      .peekAll('item')
      ?.filter((item) => item.active)
      ?.map((item) => item.id) ?? [];
  const alreadyAdded =
    location.locationItems?.map((locationItem) => locationItem.item.id) ?? [];
  const toAdd = allItems.filter((x) => !alreadyAdded.includes(x));

  const promises = [];
  for (let i = 0; i < toAdd.length; i++) {
    const item = store.peekRecord('item', toAdd[i]);
    const toSave = store.createRecord('location-item', {
      location,
      item,
      proposal_amount: 0,
    });
    promises.push(toSave.save());
    location.locationItems.push(toSave);
  }

  const locItems = location.locationItems;
  for (let i = 0; i < locItems.length; i++) {
    if (!locItems[i].item.active) {
      continue;
    }

    const stes = locItems[i].stocktakingEntries?.filter(
      (ste) => ste.stocktaking == stocktaking
    );
    if (stes.length) {
      continue;
    }
    store.createRecord('stocktaking-entry', {
      stocktaking,
      location_item: locItems[i],
      hasSetAmount: false,
      amount: 0,
    });
  }
  await Promise.all(promises);
}
